import { gql } from '@apollo/client';
import { achievementFragment } from '../fragments/achievement';

export const updateAchievementConditionsMutation = gql`
    ${achievementFragment}

    mutation UpdateAchievementConditions($achievementId: String!, $achievementConditions: [AchievementConditionCreateInput!]!) {
        updateAchievement(data: { id: $achievementId, achievementConditions: $achievementConditions }) {
            ...AchievementFields
        }
    }
`;
